import React from "react";
import "styles/component.css";
import logo from "assets/layout_img/logo.png";

const Loader = ({ message = "Yuklanmoqda..." }) => {
  return (
    <div className="loader-overlay" role="status" aria-live="polite">
      <div className="loader-box">
        <img src={logo} alt="Algoritm logo" className="loader-logo" />
        <p className="loader-text">{message}</p>
      </div>
    </div>
  );
};

export default Loader;
